/* ============================================================
   VIVĀRA — Ingredient source of truth
   ------------------------------------------------------------
   ONE continuous Rasāyana formula. Order is authoritative.
   Consumed by index.html AND product.html — never duplicate
   this list in markup.

   `group` is quiet metadata for the detail panel only. It must
   NEVER be used to visually split the list into categories,
   cards, columns or ingredient families (spec §16).

   `tradition` is what the site renders: a factual statement about the
   ingredient's role or its use in Ayurvedic tradition. It makes no claim
   about what Element 003 does.

   `benefit` holds the previous structure/function wording. It is NOT
   rendered — see js/claims.js. Supply substantiation and switch it on
   there rather than editing markup.
   ============================================================ */
(function () {
  "use strict";

  // Finished 3:5 portrait artwork from "Ingredients Images VIVARA".
  var DIR = window.VIVARA_ASSET_ROOT || "assets/img/ingredients/";
  window.VIVARA_INGREDIENTS = [
    {
      name: "Karakoram Shilajit",
      alt: null,
      group: "Primary mineral resin",
      body: "Wild-harvested primary mineral resin, rich in naturally occurring minerals.",
      tradition: "The primary mineral resin in the formula, wild-harvested in the Karakoram.",
      benefit: null,
      image: DIR + "karakoram-shilajit.jpg",
      imageAlt: "Wild-harvested Karakoram shilajit resin on dark stone"
    },
    {
      name: "Swarna Bhasma",
      alt: "Gold Ash",
      group: "Mineral preparation",
      body: "A classical Ayurvedic mineral preparation.",
      tradition: "A classical Ayurvedic bhasma — a mineral preparation with long use in Rasāyana.",
      benefit: null,
      image: DIR + "swarna-bhasma.jpg",
      imageAlt: "Fine gold ash gathered on a slab of dark stone"
    },
    {
      name: "Diamond Bhasma",
      alt: "Hira",
      group: "Mineral preparation",
      body: "A classical Ayurvedic mineral preparation.",
      tradition: "A classical Ayurvedic bhasma, prepared and used within the Rasāyana tradition.",
      benefit: null,
      image: DIR + "diamond-bhasma.jpg",
      imageAlt: "Diamond bhasma preparation on dark stone"
    },
    {
      name: "Blue Lotus Extract",
      alt: null,
      group: "Botanical",
      body: null,
      tradition: "An aromatic botanical with a long ceremonial and traditional history.",
      benefit: null,
      image: DIR + "blue-lotus.jpg",
      imageAlt: "Blue lotus flower in low editorial light"
    },
    {
      name: "Rose Absolute",
      alt: null,
      group: "Botanical",
      body: null,
      tradition: "An aromatic botanical extract, long used in Ayurvedic preparations.",
      benefit: null,
      image: DIR + "rose-absolute.jpg",
      imageAlt: "Rose petals and absolute in low editorial light"
    },
    {
      name: "Tulsi",
      alt: "Holy Basil",
      group: "Botanical",
      body: null,
      tradition: "Holy basil — among the most widely used botanicals in Ayurveda.",
      benefit: null,
      image: DIR + "tulsi.jpg",
      imageAlt: "Tulsi (holy basil) leaves in low editorial light"
    },
    {
      name: "Jatamansi Root",
      alt: "Spikenard",
      group: "Botanical",
      body: null,
      tradition: "Spikenard root, a botanical named throughout classical Ayurvedic texts.",
      benefit: null,
      image: DIR + "jatamansi.jpg",
      imageAlt: "Jatamansi (spikenard) root on dark stone"
    },
    {
      name: "Saffron Oil & Thread",
      alt: null,
      group: "Botanical",
      body: null,
      tradition: "Saffron thread and oil, long used in both Ayurvedic and culinary tradition.",
      benefit: null,
      image: DIR + "saffron.jpg",
      imageAlt: "Saffron threads and oil in low editorial light"
    },
    {
      name: "Orchid Astha Varga",
      alt: "Rare Ayurvedic tonic group",
      group: "Botanical",
      body: null,
      tradition: "One of a rare group of botanicals named in classical Ayurvedic tonic formulas.",
      benefit: null,
      image: DIR + "orchid-astha-varga.jpg",
      imageAlt: "Orchid of the Astha Varga tonic group"
    },
    {
      name: "True Ghee",
      alt: null,
      group: "Traditional carrier",
      body: "A traditional carrier used within the formula.",
      tradition: "A traditional carrier, used to bind and carry the formula.",
      benefit: null,
      image: DIR + "true-ghee.jpg",
      imageAlt: "Clarified true ghee in a dark vessel"
    },
    {
      name: "Manuka Honey",
      alt: null,
      group: "Traditional carrier",
      body: "A traditional carrier supporting nutrient delivery and the taste profile.",
      tradition: "A traditional carrier that also shapes the taste profile.",
      benefit: null,
      image: DIR + "manuka-honey.jpg",
      imageAlt: "Manuka honey drawn from a dark vessel"
    }
  ];

  window.VIVARA_FORMULATION_NOTE =
    "Formulated according to Ayurvedic Rasāyana tradition.";
})();
